import { render } from "./EnterDate.vue?vue&type=template&id=6adf08fc"
import script from "./EnterDate.vue?vue&type=script&lang=ts"
export * from "./EnterDate.vue?vue&type=script&lang=ts"
script.render = render

export default script